/*eslint-disable */
import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const state = {
  // Cached lists / indexes (perf for large datasets)
    allSorted: [],
    receivedSorted: [],
    submittedSorted: [],
    pricedSorted: [],
    orderedSorted: [],
    cancelledSorted: [],
    searchIndexById: {},perPageAll: 100,
  items: [],
  token: [],
  isPlayNotificationSound: false,
  currentRfq: 0,
  currentPSEXT: null,
  filter: '',
  searchFilterObj: {
    search: '',
  },
  lastTimeCheck: {
    items: 0,
  },
  perPage: 20,
  allRFQsCurrentPage: 1,
  receivedRFQsCurrentPage: 1,
  submittedRFQsCurrentPage: 1,
  pricedRFQsCurrentPage: 1,
  orderedRFQsCurrentPage: 1,
  cancelledRFQsCurrentPage: 1,
}

export default {
  namespaced: true,
  mutations,
  actions,
  state,
  getters,
}
